import { DOCUMENT } from '@angular/common';
import { Component, Inject, Renderer2, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { Meta, Title } from '@angular/platform-browser';
import { PageMeta } from '../../models/page-meta';
import { ReplaceMetaDatePipe } from '../../pipes/replace-meta-date.pipe';
import { PagesApiService } from '../../services/pages-api.service';
import { GeoLocationService } from '../../services/geo-location.service';
import { ContactModel } from '../../models/contact';

@Component({
  selector: 'app-contact-us',
  imports: [FormsModule],
  templateUrl: './contact-us.component.html',
  styleUrl: './contact-us.component.css',
  encapsulation: ViewEncapsulation.None
})
export class ContactUsComponent {
  pendingCalls: number = 0;
  isDataLoaded: boolean = false;
  today = new Date();
  pagemeta: PageMeta[] = [];
  emails: string = 'contactdz@gmail.com and rkpani05@gmail.com';
  contact: ContactModel = {
    FullName: '',
    Email: '',
    ContactNumber: '',
    MailSubject: '',
    MailMessage: '',
    ExtraData: ''
  };
  isSubmitting = false;
  submissionMessage = '';

  constructor(
    private siteApi: PagesApiService,
    private geoService: GeoLocationService,
    private meta: Meta,
    private title: Title,
    private replaceMetaPipe: ReplaceMetaDatePipe,
    @Inject(DOCUMENT) private dom: Document,
    private renderer: Renderer2
  ) {
    this.loadAllData();
  }

  loadAllData() {
    this.pendingCalls = 1;
    this.getPageMeta();
  }

  checkIfAllDone() {
    this.pendingCalls--;
    if (this.pendingCalls === 0) {
      this.isDataLoaded = true;
    }
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  updateMetaData(data: PageMeta) {
    const pageTitle = this.replaceMetaPipe.transform(data.PageTitle!);
    const pageDescription = this.replaceMetaPipe.transform(data.PageDescription!);
    const pageUrl = `https://www.dealszo.com/about-us/`;
    // const keyWords = data.PageKeywords!;

    // Update the title and meta tags dynamically
    this.title.setTitle(pageTitle);
    this.meta.updateTag({ name: 'title', content: pageTitle });
    this.meta.updateTag({ name: 'description', content: pageDescription });
    // this.meta.updateTag({
    //   name: 'keywords',
    //   content: keyWords,
    // });

    this.meta.updateTag({
      name: 'robots',
      content:
        'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1',
    });

    // Open Graph meta tags
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:site_name', content: 'dealszo.com' });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({
      property: 'og:description',
      content: pageDescription,
    });
    // this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({ property: 'og:url', content: pageUrl });

    let link: HTMLLinkElement = this.dom.querySelector(
      `link[rel='canonical']`
    )!;
    let alternativeLink: HTMLLinkElement = this.dom.querySelector(
      `link[rel='alternate']`
    )!;
    if (link) {
      this.renderer.setAttribute(link, 'href', pageUrl);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(link, 'rel', 'canonical');
      this.renderer.setAttribute(link, 'href', pageUrl);
      this.renderer.appendChild(this.dom.head, link);
    }
    if (alternativeLink) {
      this.renderer.setAttribute(alternativeLink, 'href', pageUrl);
    } else {
      link = this.renderer.createElement('link');
      this.renderer.setAttribute(alternativeLink, 'rel', 'canonical');
      this.renderer.setAttribute(alternativeLink, 'href', pageUrl);
      this.renderer.appendChild(this.dom.head, link);
    }

    if (data.PageSchema && data.PageSchema.trim() !== '') {
      const schema = this.replaceMetaPipe.transform(data.PageSchema);
      const jsonLdScripts = this.dom.head.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      jsonLdScripts.forEach(script => script.remove());
      const temp = this.dom.createElement('div');
      temp.innerHTML = schema;
      const scripts = temp.querySelectorAll(
        'script[type="application/ld+json"]'
      );
      scripts.forEach((scriptTag, index) => {
        const newScript = this.dom.createElement('script');
        newScript.type = 'application/ld+json';
        newScript.id = `schema-jsonld-${index}`;
        newScript.text = scriptTag.textContent || '';
        this.dom.head.appendChild(newScript);
      });
    }
  }

  getPageMeta() {
    this.siteApi.getPagesMeta().subscribe((data) => {
      if (data.Message === 'Data Fetched Successfully!!!') {
        this.pagemeta = data.Data;
        this.updateMetaData(
          this.pagemeta.find((p) => p.PageName?.includes('contact'))!
        );
      } else {
      }
      this.checkIfAllDone();
    });
  }

  submitContact(form: NgForm) {
    if (!form.valid || this.isSubmitting) {
      return;
    }

    this.geoService.getGeolocation().subscribe((data) => {
      this.isSubmitting = true;
      this.submissionMessage = '';
      const contact: ContactModel = {
        ...this.contact,
        ExtraData: JSON.stringify({
          page: window.location.pathname,
          source: 'website',
          ip: data.ip,
          country: data.country,
          city: data.city,
          region: data.region,
          code: data.postal,
          rawIpData: data
        })
      };

      this.siteApi.postContact(contact).subscribe({
        next: (response) => {
          this.submissionMessage = response.Message || 'Your message was sent successfully.';
          if (response.Message) {
            form.resetForm();
          }
        },
        error: () => {
          this.submissionMessage = 'Unable to send your message. Please try again.';
          this.isSubmitting = false;
        },
        complete: () => {
          this.isSubmitting = false;
        }
      });
    });
  }

}
